import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { FISP_TV_ADMIN_HOME_PATH } from "./config";
import { getFispTvAdminFallbackPath, isFispTvAdminAuthenticated, loginFispTvAdmin } from "./session";

export default function FispTvAdminLogin() {
    const location = useLocation();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        setError("");
    }, [password]);

    if (isFispTvAdminAuthenticated()) {
        return <Navigate to={FISP_TV_ADMIN_HOME_PATH} replace />;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!loginFispTvAdmin(password)) {
            setError("La contraseña no coincide. Probá nuevamente.");
            return;
        }

        const nextPath = location.state?.from || getFispTvAdminFallbackPath();
        navigate(nextPath, { replace: true });
    };

    return (
        <AdminLayout showNavLinks={false} centered={true}>
            <section className="tv-admin-login-stage">
                <form className="tv-admin-login-card tv-admin-login-form" onSubmit={handleSubmit}>
                    <label htmlFor="tv-admin-password">Contraseña</label>
                    <input
                        id="tv-admin-password"
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        placeholder="Ingresar contraseña"
                        autoComplete="current-password"
                        required
                    />

                    {error ? <p className="tv-admin-error">{error}</p> : null}

                    <button type="submit" className="tv-admin-primary-btn">
                        Ingresar
                    </button>
                </form>
            </section>
        </AdminLayout>
    );
}
